import './location-dropdown.scss';

const LocationDropdown = (props) => {
	const { locations } = props;

	const handleLocationClick = (country_code) => {
		localStorage.setItem('location', country_code);
		localStorage.setItem('show_redirect_message', 'false');
	};

	return (
		<>
			<ul className="location-dropdown">
				{locations.map((location, index) => (
					<li key={index}>
						<a
							onClick={() =>
								handleLocationClick(location.country_code)
							}
							className="location-dropdown__location-item"
							href={location.site_url}
							{...(location.default && {
								'data-location': location.country_code,
							})}
						>
							<img
								className="location-dropdown__flag"
								src={location.flag_URL}
								alt="selected location flag"
							></img>
							<p className="location-dropdown__location">
								<span className="location-dropdown__code">
									{location.country_code} {' - '}
									{location.language}
								</span>
							</p>
						</a>
					</li>
				))}
			</ul>
		</>
	);
};

export default LocationDropdown;
